const translate = {
  table_header: {
    availability_sets: {
      en: 'Availability Sets',
      es: 'Conjuntos de Disponibilidad',
      fr: 'Ensembles de Disponibilité',
      de: 'Verfügbarkeitsgruppen',
      pt: 'Conjuntos de Disponibilidade',
      pl: 'Zestawy Dostępności',
      nl: 'Beschikbaarheidssets',
      el: 'Σύνολα Διαθεσιμότητας',
      cs: 'Sady Dostupnosti',
      sv: 'Tillgänglighetsset',
      hu: 'Elérhetőségi Készletek',
      da: 'Tilgængelighedssæt',
      fi: 'Saatavuusryhmät',
      sk: 'Sady Dostupnosti',
      bg: 'Набори за Наличност',
      hr: 'Setovi Raspoloživosti',
      lt: 'Prieinamumo Rinkiniai',
      lv: 'Pieejamības Komplekti',
      et: 'Saadavuse Komplektid',
      sl: 'Nabori Razpoložljivosti',
      ga: 'Táirgí Infhaighteachta',
      mt: 'Settijiet ta’ Disponibbiltà',
      cy: 'Setiau Argaeledd',
      ro: 'Seturi de Disponibilitate',
      it: 'Set di Disponibilità',
      zh_cn: '可用性集',
      hi: 'उपलब्धता सेट',
      ar: 'مجموعات التوفر',
      bn: 'প্রাপ্যতা সেট',
      ru: 'Наборы Доступности',
      ja: '利用可能セット',
      tr: 'Kullanılabilirlik Setleri',
      ko: '가용성 세트',
      vi: 'Bộ Sẵn Có',
      id: 'Set Ketersediaan',
      th: 'ชุดความพร้อมใช้งาน',
      ms: 'Set Ketersediaan',
      ar_eg: 'مجموعات الإتاحة',
      uk: 'Набори Наявності',
    },
  },
  button: {
    en: 'Manage Availability',
    es: 'Gestionar Disponibilidad',
    fr: 'Gérer la Disponibilité',
    de: 'Verfügbarkeit Verwalten',
    pt: 'Gerir Disponibilidade',
    pl: 'Zarządzaj Dostępnością',
    nl: 'Beschikbaarheid Beheren',
    el: 'Διαχείριση Διαθεσιμότητας',
    cs: 'Spravovat Dostupnost',
    sv: 'Hantera Tillgänglighet',
    hu: 'Elérhetőség Kezelése',
    da: 'Administrer Tilgængelighed',
    fi: 'Hallinnoi Saatavuutta',
    sk: 'Spravovať Dostupnosť',
    bg: 'Управление на Наличността',
    hr: 'Upravljanje Raspoloživošću',
    lt: 'Tvarkyti Prieinamumą',
    lv: 'Pārvaldīt Pieejamību',
    et: 'Halda Saadavust',
    sl: 'Upravljanje z Razpoložljivostjo',
    ga: 'Bainistigh Infhaighteacht',
    mt: 'Immaniġġja d-Disponibbiltà',
    cy: 'Rheoli Argaeledd',
    ro: 'Gestionați Disponibilitatea',
    it: 'Gestisci Disponibilità',
    zh_cn: '管理可用性',
    hi: 'उपलब्धता प्रबंधित करें',
    ar: 'إدارة التوفر',
    bn: 'উপস্থিতি পরিচালনা করুন',
    ru: 'Управление Наличием',
    ja: '可用性の管理',
    tr: 'Kullanılabilirliği Yönet',
    ko: '가용성 관리',
    vi: 'Quản lý Tính Sẵn Có',
    id: 'Kelola Ketersediaan',
    th: 'จัดการความพร้อมใช้งาน',
    ms: 'Urus Ketersediaan',
    ar_eg: 'إدارة الإتاحة',
    uk: 'Керувати Наявністю',
  },
  toggle: {
    en: 'Availability is the same for all the sales types',
    es: 'La disponibilidad es la misma para todos los tipos de ventas',
    fr: 'La disponibilité est la même pour tous les types de ventes',
    de: 'Die Verfügbarkeit ist für alle Verkaufsarten gleich',
    pt: 'A disponibilidade é a mesma para todos os tipos de vendas',
    pl: 'Dostępność jest taka sama dla wszystkich typów sprzedaży',
    nl: 'De beschikbaarheid is hetzelfde voor alle soorten verkopen',
    el: 'Η διαθεσιμότητα είναι ίδια για όλους τους τύπους πωλήσεων',
    cs: 'Dostupnost je stejná pro všechny typy prodeje',
    sv: 'Tillgängligheten är densamma för alla försäljningstyper',
    hu: 'Az elérhetőség minden értékesítési típusnál ugyanaz',
    da: 'Tilgængeligheden er den samme for alle salgstyper',
    fi: 'Saatavuus on sama kaikille myyntityypeille',
    sk: 'Dostupnosť je rovnaká pre všetky typy predaja',
    bg: 'Наличността е еднаква за всички видове продажби',
    hr: 'Dostupnost je ista za sve vrste prodaje',
    lt: 'Prieinamumas yra toks pat visų pardavimo tipų atveju',
    lv: 'Pieejamība ir tāda paša visiem pārdošanas veidiem',
    et: 'Saadavus on sama kõigi müügitüüpide jaoks',
    sl: 'Razpoložljivost je enaka za vse vrste prodaje',
    ga: 'Tá an infhaighteacht mar an gcéanna do gach cineál díolacháin',
    mt: 'Id-disponibbiltà hija l-istess għal kull tip ta’ bejgħ',
    cy: 'Mae argaeledd yr un fath ar gyfer pob math o werthu',
    ro: 'Disponibilitatea este aceeași pentru toate tipurile de vânzări',
    it: 'La disponibilità è la stessa per tutti i tipi di vendita',
    zh_cn: '所有销售类型的可用性相同',
    hi: 'सभी बिक्री के प्रकारों के लिए उपलब्धता समान है',
    ar: 'التوفر هو نفسه لجميع أنواع المبيعات',
    bn: 'সব বিক্রয়ের ধরনের জন্য উপলব্ধতা একই',
    ru: 'Доступность одинакова для всех типов продаж',
    ja: 'すべての販売タイプで利用可能性は同じです',
    tr: 'Tüm satış türleri için kullanılabilirlik aynıdır',
    ko: '모든 판매 유형에 대한 가용성이 동일합니다',
    vi: 'Khả năng có sẵn là như nhau cho tất cả các loại bán hàng',
    id: 'Ketersediaan sama untuk semua jenis penjualan',
    th: 'การมีจำหน่ายเหมือนกันสำหรับทุกประเภทการขาย',
    ms: 'Ketersediaan adalah sama untuk semua jenis jualan',
    ar_eg: 'التوافر هو نفسه لجميع أنواع المبيعات',
    uk: 'Наявність однакова для всіх типів продажу',
  },
  select_availability: {
    en: 'Select Availability',
    es: 'Seleccionar Disponibilidad',
    fr: 'Sélectionner la Disponibilité',
    de: 'Verfügbarkeit Auswählen',
    pt: 'Selecionar Disponibilidade',
    pl: 'Wybierz Dostępność',
    nl: 'Beschikbaarheid Selecteren',
    el: 'Επιλέξτε Διαθεσιμότητα',
    cs: 'Vybrat Dostupnost',
    sv: 'Välj Tillgänglighet',
    hu: 'Elérhetőség Kiválasztása',
    da: 'Vælg Tilgængelighed',
    fi: 'Valitse Saatavuus',
    sk: 'Vybrať Dostupnosť',
    bg: 'Изберете Наличност',
    hr: 'Odaberite Raspoloživost',
    lt: 'Pasirinkite Prieinamumą',
    lv: 'Izvēlēties Pieejamību',
    et: 'Vali Saadavus',
    sl: 'Izberite Razpoložljivost',
    ga: 'Roghnaigh Infhaighteacht',
    mt: 'Agħżel id-Disponibbiltà',
    cy: 'Dewiswch Argaeledd',
    ro: 'Selectați Disponibilitatea',
    it: 'Seleziona Disponibilità',
    zh_cn: '选择可用性',
    hi: 'उपलब्धता चुनें',
    ar: 'اختر التوفر',
    bn: 'উপলব্ধতা নির্বাচন করুন',
    ru: 'Выбрать Наличие',
    ja: '利用可能性を選択',
    tr: 'Kullanılabilirliği Seç',
    ko: '가용성 선택',
    vi: 'Chọn Tính Sẵn Có',
    id: 'Pilih Ketersediaan',
    th: 'เลือกความพร้อมใช้งาน',
    ms: 'Pilih Ketersediaan',
    ar_eg: 'اختر الإتاحة',
    uk: 'Вибрати Наявність',
  },
}
export default translate
